// extracted by mini-css-extract-plugin
export default {"root":"_2dKIHuTy","faded":"_3GAVHRdg","header":"_2Ed4p3o1"};